import GROUP_TYPES from '@/lib/types';
import { FRAGMENTS as COMMON_FRAGMENTS } from '@repo/ui/lib';

const FEATURED_PROJECTS_LINKS_QUERY = `
    ... on ${GROUP_TYPES.PAGES.DIGITAL_ALL_PROJECTS_PAGE} {
        slug
    }
`;

const FEATURED_PROJECTS_GRID_QUERY = `
    ... on ${GROUP_TYPES.PAGES.DESIGN_SINGLE_PROJECT} {
        __typename
        id
        name
        slug
        description
        highlight
        projectColor {
            hex
        }
        project
        projectCategories {
            projectCategory
            projectCategoryId
        }
        projectServiceRange {
            serviceName
        }
        year
        ${COMMON_FRAGMENTS.THEME_FRAGMENT}
        coverPortrait {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        coverLandscape {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        video {
            ${COMMON_FRAGMENTS.VIDEO_FRAGMENT}
        }
        description
        bannerWhiteLogo
        bannerWhiteMenu
    }
    ... on ${GROUP_TYPES.PAGES.DIGITAL_SINGLE_PROJECT} {
        __typename
        id
        name
        slug
        description
        highlight
        projectColor {
            hex
        }
        project
        projectCategories {
            projectCategory
            projectCategoryId
        }
        projectServiceRange {
            serviceName
        }
        year
        ${COMMON_FRAGMENTS.THEME_FRAGMENT}
        coverPortrait {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        coverLandscape {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
        }
        video {
            ${COMMON_FRAGMENTS.VIDEO_FRAGMENT}
        }
        description
        bannerWhiteLogo
        bannerWhiteMenu
    }
`;
const FEATURED_PROJECTS_FRAGMENT = COMMON_FRAGMENTS.FEATURED_PROJECTS_FRAGMENT_FUNCTION(
	[FEATURED_PROJECTS_LINKS_QUERY],
	[FEATURED_PROJECTS_GRID_QUERY],
);

const DESCRIPTION_LOGO_PLEO_LINKS_QUERY = `
    ... on ${GROUP_TYPES.PAGES.DIGITAL_SINGLE_PAGE} {
        slug
    }
`;
const DESCRIPTION_LOGO_PLEO_FRAGMENT = COMMON_FRAGMENTS.DESCRIPTION_LOGO_PLEO_FRAGMENT_FUNCTION([DESCRIPTION_LOGO_PLEO_LINKS_QUERY]);

const NEWS_THUMBNAILS_BUTTON_LINKS_QUERY = `
    ... on ${GROUP_TYPES.PAGES.DIGITAL_SINGLE_PAGE}{
        slug
    }
    ... on ${GROUP_TYPES.PAGES.SINGLE_PAGE} {
        slug
    }
`;
const NEWS_THUMBNAILS_FRAGMENT = COMMON_FRAGMENTS.NEWS_THUMBNAILS_FRAGMENT_FUNCTION([NEWS_THUMBNAILS_BUTTON_LINKS_QUERY]);

const CHECK_OTHERS_LINKS_QUERY = `
    ... on ${GROUP_TYPES.PAGES.DIGITAL_SINGLE_PAGE} {
        slug
        name
    }
    ... on ${GROUP_TYPES.PAGES.DIGITAL_ALL_PROJECTS_PAGE} {
        slug
        name
    }
`;
const CHECK_OTHERS_FRAGMENT = COMMON_FRAGMENTS.CHECK_OTHERS_MODULE_FRAGMENT_FUNCTION([CHECK_OTHERS_LINKS_QUERY]);

const FAQ_FRAGMENT = COMMON_FRAGMENTS.FAQ_FRAGMENT;
const ABOUT_TEAM_FRAGMENT = COMMON_FRAGMENTS.ABOUT_TEAM_FRAGMENT;
const SINGLE_ASSET_FRAGMENT = COMMON_FRAGMENTS.SINGLE_ASSET_FRAGMENT;

const ALL_NEWS_PRESENTATION_FRAGMENT = `
    ... on ${GROUP_TYPES.ALL_NEWS_PRESENTATION}{
        featuredHeading
        chooseArticle {
          title
          blogPageName
          slug
          _createdAt
          pleoCategory
          categories
          wordsCount
          thumbnailImage {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
          }
          thumbnailImageHorizontal {
            ${COMMON_FRAGMENTS.IMAGE_FRAGMENT}
          }
        }
        pleoSpacesHeading
        pleoSpaces {
          text
          pleo
        }
        filtrationHeading
        loadMoreButtonText
    }
`;

export default {
	FEATURED_PROJECTS_FRAGMENT,
	DESCRIPTION_LOGO_PLEO_FRAGMENT,
	NEWS_THUMBNAILS_FRAGMENT,
	ABOUT_TEAM_FRAGMENT,
	CHECK_OTHERS_FRAGMENT,
	SINGLE_ASSET_FRAGMENT,
	FAQ_FRAGMENT,
	ALL_NEWS_PRESENTATION_FRAGMENT,
};
